import React, {useEffect, useState, Fragment} from "react";
import MaterialSpinner from "../../../ui/materialSpinner";
import {baseNewImagesPath} from "../../../assets";
import {THUMBNAIL_SIZES} from "../../../../misc/utils";
import {featureThumbnailUrl} from "../../../../misc/helpers";
import ShopFeatureImageGalleryItem from "./shopFeatureImageGalleryItem";


const ShopFeatureImage = (props) => {

  const {feature} = props;

  const [isLoading, toggleLoader] = useState(true);
  const [galleryImages, setGalleryImages] = useState([]);
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  const mainImageUrl = galleryImages[activeImageIndex];

  useEffect(() => {
    let featureGalleryImages = (feature.dbFeature.galleryEnabled && Array.isArray(feature.dbFeature.galleryImages)
      && feature.dbFeature.galleryImages.length) ? feature.dbFeature.galleryImages : [];
    setGalleryImages([{
      url: featureThumbnailUrl(feature) || `${baseNewImagesPath}images/image-not-found.png`,
      preview: featureThumbnailUrl(feature, THUMBNAIL_SIZES.medium)
    },  // main image thumbnail
      ...featureGalleryImages
    ]);
    setActiveImageIndex(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [feature]);

  const galleryImageClick = (galleryImageIndex) => {
    if (galleryImageIndex !== activeImageIndex) {
      toggleLoader(true);
      setActiveImageIndex(galleryImageIndex)
    }
  }

  return (
    <Fragment>
      <div className="shop-feature__image">
        {isLoading || !mainImageUrl ? <MaterialSpinner/> : null}
        <div className="lk-image__main-image-container">
          {mainImageUrl ? <img className={"lk-image__main-image" + (isLoading ? " lk-image__main-image--loading" : "")}
            // onClick={() => thumbnailClick(activeImageIndex)}
                               src={mainImageUrl.url} onLoad={() => toggleLoader(false)} alt=""/> : null}
        </div>
      </div>
      {galleryImages.length > 1 ? (
        <ul className={"shop-feature__gallery" + (galleryImages.length > 5 ? " shop-feature__gallery--left" : "")}>
          {galleryImages.map((galleryImage, galleryImageIndex) => {
            return <ShopFeatureImageGalleryItem key={galleryImage.url || "galleryImage" + galleryImageIndex}
                                                galleryImage={galleryImage}
                                                galleryImageIndex={galleryImageIndex}
                                                galleryImageClick={galleryImageClick}/>
          })}
        </ul>
      ) : null}
    </Fragment>
  )
};

export default ShopFeatureImage
